export const getDefaultReportDates = () => {
  const to = new Date();
  const from = new Date(to);
  from.setDate(from.getDate() - 30);
  return { DEFAULT_FROM_DATE: from, DEFAULT_TO_DATE: to };
};
